import React from "react";

export const MyBooksIcon = (): JSX.Element => {
  return (
    <svg
      width="18"
      height="16"
      viewBox="0 0 18 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.52031 3.4566L9 3.8557L9.47969 3.45659C11.8482 1.48592 15.3363 0.941615 17.0657 0.798626C17.1164 0.794433 17.1557 0.810372 17.1876 0.841191C17.2219 0.874195 17.25 0.928153 17.25 1V11.16C17.25 11.2941 17.1284 11.46 16.923 11.4826C15.2865 11.6629 11.9444 12.3065 9.29087 14.6576C9.13079 14.7995 8.86921 14.7995 8.70913 14.6576C6.05562 12.3065 2.71347 11.6629 1.07704 11.4826C0.871628 11.46 0.75 11.2941 0.75 11.16V1.00001C0.75 0.928159 0.778148 0.874201 0.81236 0.841197C0.844308 0.810377 0.883591 0.794438 0.9343 0.798631C2.6637 0.941629 6.15176 1.48594 8.52031 3.4566Z"
        stroke="#212121"
        strokeWidth="1.5"
      />
      <path d="M9 3V9.5V14" stroke="#212121" strokeWidth="1.5" />
    </svg>
  );
};
